import CONNECT from '../actionTypes/websocket';

export default {
  connectWebsocket: (webSocket) => ({
    type: CONNECT,
    payload: {
      webSocket,
    },
  }),
};
